import { createFileRoute } from '@tanstack/react-router';
import { TrackPage } from '@/page/TrackPage';

export const Route = createFileRoute('/_app/tracks/$trackId/')({ component: TrackRoute });

function TrackRoute() {
  const { trackId } = Route.useParams();
  return <TrackPage trackId={trackId} />;
}
